import * as React from 'react';
import { Layout, Menu, Icon, Dropdown, Button, Divider } from 'antd';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';

import { ROUTE_NAMES } from '@bakbak/common';
import { MeQuery_me } from '@bakbak/controller';
import { SearchBarComponent } from './SearchBarComponent';
import { THEME_COLOR } from '../../../constants';
// import logo from '../../../../public/logo.png';

const { Header } = Layout;

interface Props {
  loggedUser: MeQuery_me
}

export class HeaderLoggedUserC extends React.PureComponent<RouteComponentProps<{}> & Props> {
  gotoCreatePost = () => {
    this.props.history.push(ROUTE_NAMES.CREATE_POST);
  }

  renderSearch = () => (
    <React.Fragment>
      <Link to={ROUTE_NAMES.HOME} style={{ marginRight: 20, color: THEME_COLOR, marginTop: 5 }}>
        {/* <img src={logo} alt="logo" height="45" width="45" /> */}
        <Icon type="home" style={{ fontSize: '28px', }} />
      </Link>
      <SearchBarComponent />
    </React.Fragment>
  )

  render() {
    const renderProfileMenu = (
      <Menu style={{ minWidth: 200 }}>
        <Menu.Item key="0">
          <Link to={ROUTE_NAMES.MY_PROFILE}> Profile </Link>
        </Menu.Item>
        <Menu.Divider />
        {/* <Menu.Item key="3" disabled={true}>Settings</Menu.Item> */}
        {/* <Menu.Divider /> */}
        <Menu.Item key="1">
          <Link to={ROUTE_NAMES.LOGOUT}>Logout</Link>
        </Menu.Item>
      </Menu>
    );
    return (
      <div>
        <Header className="header" style={{ background: '#fff', display: 'flex', flexDirection: 'row', height: 'auto', borderBottom: 0 }}>
          {this.renderSearch()}
          <div style={{ marginLeft: 'auto' }}>
            <Button onClick={this.gotoCreatePost} style={createPostButtonStyle}>
              Create Post
            </Button>
            {/* <Menu mode="horizontal" style={{ borderColor: "white", lineHeight: 5, marginRight: 20 }}>
              <React.Fragment>
                
              </React.Fragment>

              {/* <Menu.Item key="1">
                <div style={{ marginLeft: 20, marginRight: 20 }}>
                  Notifications
                </div>
              </Menu.Item> 

            </Menu> */}
          </div>
          <Dropdown overlay={renderProfileMenu}>
            <a className="ant-dropdown-link" href="#" style={{ color: "grey" }}>
              <Icon type="user" style={{ fontSize: '20px', }} />
              <Icon type="down" style={{ fontSize: '15px', }} />
            </a>
          </Dropdown>
        </Header>
        <Divider style={{ margin: 0 }} />
      </div>
    );
  }
}

const createPostButtonStyle = {
  backgroundColor: THEME_COLOR,
  color: "white",
  borderColor: THEME_COLOR,
  marginRight: 20,
};

export const HeaderLoggedUserView = withRouter(HeaderLoggedUserC);


// WEBPACK FOOTER //
// ./src/modules/layout/header/HeaderLoggedUserView.tsx